var fd = {
	init: function(page) {
		if (fd[page] && fd[page].init) {
			fd[page].init();
		}

		$(".sm-header-menu a:first").dropdown()

		fd.on.scroll(function() {
		    $("body").toggleClass("minimized", $(this).scrollTop() > 0);
		}, true);

		//fd.navigation.init();
	},
	on: {
	    resize: function(fnc, callOnload) {
	        $(window).on("resize", fnc);

	        callOnload && fnc();
	    },
	    scroll: function(fnc, callOnload) {
	        $(window).on("scroll", fnc);

            callOnload && fnc();
	    }
	}
};

(function () {
    $.fn.dialog = function(options) {
    	var modal = $(".modal");

    	options = $.extend({
    		buttons: ["default"]
    	}, options);

        if (modal.length === 0) {
        	$("body").append(
    			'<div class="modal fade">' +
    			  '<div class="modal-dialog">' +
    			    '<div class="modal-content">' +
    			      '<div class="modal-header">' +
    			        '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
    					  '<span aria-hidden="true">&times;</span>' +
    					'</button>' +
    			        '<h4 class="modal-title"></h4>' +
    			      '</div>' +
    			      '<div class="modal-body"></div>' +
    			      '<div class="modal-footer"></div>' +
    			    '</div>' +
    			  '</div>' +
    			'</div>');
        	modal = $(".modal");
        }

        var body = modal.find(".modal-body"),
        	footer = modal.find(".modal-footer");

        body.children().remove();
        footer.children().remove();

        body.append($(this).clone().show());
        modal.find(".modal-title").text(options.title);

        $.each(options.buttons, function(i, button) {
        	if (button == "close") {
        		button = {
					text: "Close",
					click: "close"
				};
        	}

        	var o = $(
    			'<button type="button" class="btn btn-' + (button.type || 'default') + '"' +
    				(button.click == "dismiss" ? ' data-dismiss="modal"' : '') + '>' +
    				button.text +
				'</button>'
			);

        	if (button.click == "close") {
        		o.attr("data-dismiss", "modal");
        	}
        	else if (typeof button.click == "string") {
        		o.click(function() {
        			window.open(button.click, "_blank");
        		});
        	}
        	else {
        		o.click(button.click);
        	}

        	footer.append(o);
        });

        modal.modal("show");
    };

    $.fn.dimensions = function() {
        return {
            width: $(this).width(),
            height: $(this).height()
        };
    };
})();